const imgPath = '/static/img/yearluck/y2023/'

import pkg01 from './counselor/pkg01_hoshi_hitomi'
import pkg02 from './counselor/pkg02_kurenotori'
import pkg03 from './counselor/pkg03_shiuma'
import pkg04 from './counselor/pkg04_touwa'
import pkg05 from './counselor/pkg05_somari_mone'
import pkg06 from './counselor/pkg06_houen'
import pkg07 from './counselor/pkg07_kanou_coco'
import pkg08 from './counselor/pkg08_suisho_tamako'


export const PACKAGE_INFO = [pkg01, pkg02, pkg03, pkg04, pkg05, pkg06, pkg07, pkg08]

export const TOP_FREE_MENUS = [
  {
    title: '81種の鳳凰タイプで自分がわかる！暮れの酉の鳳凰数術',
    thumbnail: `${imgPath}top/type_houou.png`,
    url: '/recommend/lp/1/basic/input',
  },
  {
    title: '宿る神・守り星・属性で自分の可能性がわかる！斗弥の属性開抛',
    thumbnail: `${imgPath}top/type_zokusei.png`,
    url: '/recommend/lp/3/basic/input',
  },
  {
    title: '暴露数で本当の自分と眠れる才がわかる！法演のMITSURI',
    thumbnail: `${imgPath}top/type_mitsuri.png`,
    url: '/recommend/lp/4/basic/input',
  },
  {
    title: '天から授かった魅力がわかる！叶ここの天宝占術',
    thumbnail: `${imgPath}top/type_hana.png`,
    url: '/recommend/lp/2/basic/input',
  },
  {
    title: 'ねこタイプで周りからの印象・長所がわかる！そまり百音のねこ風水',
    thumbnail: `${imgPath}top/type_neko.png`,
    url: '/recommend/lp/6/basic/input',
  },
  {
    title: 'キャラタイプであなたが秘める能力がわかる！オッティモちゃんの宇宙占術RPU',
    thumbnail: `${imgPath}top/type_rpu.png`,
    url: '/recommend/lp/5/basic/input',
  },
]



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/consts.js